import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
declare var $: any;

@Component({
  selector: 'app-megaheader',
  templateUrl: './megaheader.component.html',
  styleUrls: ['./megaheader.component.css']
})
export class MegaheaderComponent implements OnInit {
  route:string = '';

  constructor(location: Location, public router: Router) {
    router.events.subscribe((val) => {
      if(location.path() != ''){
        if($('.header').hasClass('landingpage')){
          $(".header").removeClass("landingpage");
        }        
      }
      this.showHideNavbarMobile('hide');
    });
  }

  ngOnInit(): void {

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $(".header").addClass("stickyhdr");
      } else {
        $(".header").removeClass("stickyhdr");
      }
    });
    this.showHideNavbarMobile('hide');
  }

  showHideNavbarMobile(action:string){
    if(action == 'show'){
      $("#navbar-mobile-nav").show(300);
    }else if(action == 'hide'){
      $("#navbar-mobile-nav").hide(300);
    }
  }

}
